export const WIDGET_GET_DEVICES_COUNT = 'widget-get-devices-count';
export const WIDGET_GET_DEVICES_COUNT_RESULT = `${WIDGET_GET_DEVICES_COUNT}/result`;
export const WIDGET_GET_DEVICES_COUNT_ERROR = `${WIDGET_GET_DEVICES_COUNT}/error`;
